export const GET_NOTIFICATIONS_READONE = (id: string) => {
  return `/notifications/readone/${id}`
}
